import React from 'react';
import './DidYouKnow.css';

import Icon from '../../../components/Icon/Icon';

const didYouKnow = ( props ) => {
	return (
		<section id="DidYouKnow">
			<h2>Did <span>You</span> Know?</h2>
			<div>
				{
					props.list.map( item => (
						<div className="dyk-info" key={ item.id }>
							<Icon icon={ 'about.' + item.icon } title={ item.title } gradient="vertical" />
							<p>{ item.text }</p>
						</div>
					))
				}
			</div>
		</section>
	);
};

export default didYouKnow;



// WEBPACK FOOTER //
// ./src/pages/About/DidYouKnow/DidYouKnow.js